import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';

class OffCanvas extends Component {

    constructor(props) {
        super(props);

        this.state = {
            menuItems: [
                {
                    url: '/',
                    text: 'Home'
                },
                {
                    url: '/about',
                    text: 'About'
                },
                {
                    url: '/work',
                    text: 'Work'
                },
                {
                    url: '/blog',
                    text: 'Blog'
                },{
                    url: '/hello',
                    text: 'Say hello'
                }
            ]
        }
        this.navigateHandler = this.navigateHandler.bind(this);
    }

    navigateHandler() {
        this.props.onChange();
    }

    render() {
        const { menuItems } = this.state

        return (
            <div className="off-canvas" {...this.props}>
                <div className="off-canvas__inner">
                    <nav className="navigation">
                        <ul className="navigation__list">
                            {menuItems.map(({url, text}, k) => {
                                return (
                                    <li key={k} data-num={'0' + (k+1)} className="navigation__list-item">
                                        <NavLink onClick={this.navigateHandler} exact={url === '/'} className="navigation__link" activeClassName="navigation__link--active" to={url}>
                                            {text}
                                        </NavLink>
                                    </li>
                                )
                            })}
                        </ul>
                    </nav>
                </div>
            </div>
        );
    }
}

export default OffCanvas;



// WEBPACK FOOTER //
// ./src/components/Global/OffCanvas.js